export const DEFAULT_ERROR_MESSAGE = "Došlo je do greške. Pokušajte ponovo za nekoliko trenutaka."
export const NUMBER_OF_ARTICLES_ON_PAGE = 20
export const NUMBER_OF_ARTICLES_IN_CENTRAL = 5

/** EXTERNAL URLS */
export const ORCID_ROOT = "https://orcid.org/"
export const HISTORIA_MODERNA_URL = "https://historiamoderna.umhis.ba/index.php/ojs"
export const HISTORY_FEST_URL = "https://historyfest.ba/"

/** ADDVERTISEMENT IMAGE NAMES */
export const HISTORIA_MODERNA_IMAGE_NAME = "tn_HISTORIA-MODERNA-2023-omot.jpg"
export const HISTORY_FEST_IMAGE_NAME = "tn_historyfest.jpg"

/** API RESPONSE MESSAGES */
export const ALREADY_GENERATED_RESPONSE = "ALREADY GENERATED"
export const OK_RESPONSE = "OK"
export const CHANGE_PASSWORD_OK_RESPONSE = "Password successfully changed"

/** MODAL TYPES */
export const MODAL_TYPE_SUCCESS = "success"
export const MODAL_TYPE_ERROR = "error"
export const MODAL_TYPE_WARNING = "warning"

/** MODAL MESSAGES */
export const MODAL_MESSAGE_SUCCESS_REQUEST = "Uspješan zahtjev"
export const MODAL_MESSAGE_SUCCESS_REGISTRATION = "Uspješna registracija"
export const MODAL_MESSAGE_ERROR = "Greška"
export const MODAL_MESSAGE_WARNING = "Upozorenje"
export const MODAL_MESSAGE_PROCESSING = "Zahtjev se obrađuje..."

/** MODAL DESCRIPTIONS */
export const MODAL_DESCRIPTION_SUCCESS_REGISTRATION = "Uspješno ste se registrovali. Uskoro ćete dobiti email sa linkom za aktivaciju računa."
export const MODAL_DESCRIPTION_SUCCESS_REQUEST_RESET_PASS = "Uskoro ćete dobiti email sa linkom za reset lozinke."
export const MODAL_DESCRIPTION_SUCCESS_RESET_PASSWORD = "Uspješno ste promijenili svoju lozinku. Preusmjerit ćemo Vas na početnu stranicu."
export const MODAL_DESCRIPTION_SUCCESS_CHANGE_PASSWORD = "Uspješno ste promijenili svoju lozinku. Prijavite se ponovo."
export const MODAL_DESCRIPTION_ERROR_ARTICLE_SEARCH_INVALID = "Pretraga nije ispravna."
export const MODAL_DESCRIPTION_ERROR_ARTICLE_NOT_FOUND = "Članak nije pronađen. Provjerite da li je ispravan url."
export const MODAL_DESCRIPTION_PLEASE_WAIT = "Molimo sačekajte"

export const MODAL_DESCRIPTION_SUCCESS_NEW_COMMENT = "Uspješno ste dodali komentar! Molimo sačekajte da Vaš komentar bude odobren."

export const MODAL_DESCRIPTION_ERROR_RESET_PASSWORD = "Molimo zatražite ponovo reset lozinke. Preusmjerit ćemo Vas na početnu stranicu."
export const MODAL_DESCRIPTION_ERROR_UNAUTHORIZED = "Vaša sesija je istekla, prijavite se opet."
